import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#f87676",
        secondary: "#30384d",
      },
    },
  },
});

export default vuetify;
